export const XERO_STATUS = ['AUTHORISED', 'DELETED', 'DRAFT', 'PAID', 'SUBMITTED', 'VOIDED'];
